import { useCallback, useState } from 'react'

function useStorage(
  storage: Storage,
  key: string
): [string | null, (value: string | null) => void] {
  const [value, setValue] = useState<string | null>(() => {
    try {
      return storage.getItem(key)
    } catch {
      return null
    }
  })

  const set = useCallback(
    (next: string | null) => {
      try {
        if (next === null) {
          storage.removeItem(key)
        } else {
          storage.setItem(key, next)
        }
      } catch {
        // Storage may be unavailable (private browsing, quota exceeded)
      }
      setValue(next)
    },
    [storage, key]
  )

  return [value, set]
}

export function useSessionStorage(key: string) {
  return useStorage(sessionStorage, key)
}

export function useLocalStorage(key: string) {
  return useStorage(localStorage, key)
}
